import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { InfoCards, retentionTooltipIcons, stackedBarLegendItems } from "../../_models";
import {
  BarChartType,
  CardLoaderSize,
  DoughnutChartData,
  InlineTableData,
  PerfTableColumn,
  retentionValueCols,
} from "../data-visualization";
import { DashboardTabAbstractComponent } from "../dashboard-tab-abstract.component";
import { ReportDimensions } from "../../reports/models/reports";
import {
  OrdersInfo,
  OrdersBillingDualCard,
  OrdersBillingSingleCard,
  ProductViewType,
  ordersBillingDualCards,
  ordersBillingSingleCards,
  ordersBillingState,
  ordersCampaignData,
  ordersCancellationReasons,
  ordersCustomerStageData,
  ordersDoughnutData,
  ordersHints,
  ordersOfferTypeData,
  ordersProductData,
  ordersSummaryTableData,
  ordersTopCards,
} from "./orders.data";

@Component({
  selector: "app-orders-dashboard",
  templateUrl: "./orders.component.html",
  styleUrls: ["./../dashboard-section.scss", "./../dashboard-section-v2.scss"],
})
export class DashboardOrdersComponent extends DashboardTabAbstractComponent implements OnInit {
  @Input() cardsLoading: boolean = false;
  @Output() reportNavigate = new EventEmitter<string>();

  /* Cards Data */
  ordersTopCards: InfoCards = ordersTopCards;
  ordersInfo = OrdersInfo;

  /* Charts Data */
  ordersDoughnutData: DoughnutChartData = ordersDoughnutData;
  ordersSummaryTableData: InlineTableData = ordersSummaryTableData;
  cancellationReasons = ordersCancellationReasons;
  offerTypeData = ordersOfferTypeData;
  productData = ordersProductData;
  campaignData = ordersCampaignData;
  customerStageData = ordersCustomerStageData;

  /* Billing Row */
  billingDualCards: OrdersBillingDualCard[] = ordersBillingDualCards;
  billingSingleCards: OrdersBillingSingleCard[] = ordersBillingSingleCards;
  billingState = ordersBillingState;

  /* Misc */
  ordersHints = ordersHints;
  retentionTooltipIcons = retentionTooltipIcons;
  stackedBarLegendItems = stackedBarLegendItems;
  barChartType = BarChartType;
  cardLoaderSize = CardLoaderSize;
  productViewTypeEnum = ProductViewType;
  productViewType: ProductViewType = ProductViewType.Base;
  reportDimensions = ReportDimensions;

  /* Perf table column definitions */
  offerTypeNameCol: PerfTableColumn = { label: 'Offer Type', field: 'name' };
  offerTypeValueCols = retentionValueCols;
  productNameCol: PerfTableColumn = { label: 'Product Name', field: 'name' };
  productValueCols = retentionValueCols;
  campaignNameCol: PerfTableColumn = { label: 'Name', field: 'name' };
  campaignValueCols = retentionValueCols;
  customerStageNameCol: PerfTableColumn = { label: 'Name', field: 'name' };
  customerStageValueCols = retentionValueCols;

  constructor() {
    super();
  }

  ngOnInit() {}

  navigateToReport(dimension: string) {
    this.reportNavigate.emit(dimension);
  }

  getAbsTrend(value: number): number {
    return Math.abs(value);
  }

  onProductViewTypeChange(type: ProductViewType) {
    this.productViewType = type;
    this.productData.type = type;
    if (type === ProductViewType.Base) {
      if (this.productData.baseData !== null) {
        this.productData.data = this.productData.baseData;
        this.productData.noData = this.productData.baseData.length === 0;
        this.productData.loading = false;
      } else {
        this.productData.loading = true;
      }
    } else {
      if (this.productData.campaignData !== null) {
        this.productData.data = this.productData.campaignData;
        this.productData.noData = this.productData.campaignData.length === 0;
        this.productData.loading = false;
      } else {
        this.productData.loading = true;
      }
    }
  }
}
